// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2a6eX","row":"ProcedureTreatmentSummary_row__s8_pE"};